import React, { useEffect, useState } from "react";
import Autolinker from "autolinker";
import DOMPurify from "dompurify";
import "./KitDetails/KitDetailsPage.css";
import { Row, Col, Container } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PageTitle from "./Common/PageTitle/PageTitle";
import KitDetails from "./KitDetails/KitDetails";
import PatientDetails from "./KitDetails/PatientDetails";
import ResultDetails from "./KitDetails/ResultDetails";
import PatientHistory from "./KitDetails/PatientHistory";
import SelectActions from "./KitDetails/SelectAction";
import Progress from "./KitDetails/Progress";
import { useLocation } from "react-router-dom";
import ApiService from "../ApiService";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { DateTime } from "luxon";
import { capitalizeWords, isValidValue } from "../util/common";
import { hasAccessToClinicalData } from "../util/authUtil";
import SingleChart from "./PatientProfileV2/PatientDashboard/ChartingNotes/SingleChart";
import { convertEpochToDate } from "../util/common";
import { BsSquareFill, BsTagsFill } from "react-icons/bs";
import { getStatusBgColor } from "../util/bookingUtils";
import { MdOutlineDangerous } from "react-icons/md";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

// Utility to sanitize and autolink external notes
const formatExternalNote = text =>
  DOMPurify.sanitize(
    Autolinker.link(text, {
      newWindow: true,
      className: "custom-link",
      truncate: { length: 60, location: "smart" }
    })
  );
const KitDetailsPage = () => {
  // styles for accordion
  const useStyles = makeStyles(theme => ({
    root: {
      width: "100%"
    },
    heading: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightRegular
    }
  }));
  const classes = useStyles();

  //get kitId from url
  const search = useLocation().search;
  const kitId = new URLSearchParams(search).get("kitId");
  const location = useLocation();
  // const kitDetail = location?.state?.kitDetails;
  const [kitDetail, setKitDetail] = useState(null);
  useEffect(() => {
    async function getKitDetails() {
      try {
        const getKitDetails = await ApiService.getKitDetialsByKitId(kitId);
        console.log(getKitDetails.data);
        setKitDetail(getKitDetails.data);
      } catch (err) {
        console.error(err);
      }
    }
    getKitDetails();
  }, [kitId]);
  const [testResult, setTestResult] = useState(null);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");
  const [hasClinicalDataAccess, setHasClinicalDataAccess] = useState(false);
  const [preSignedResultUrls, setPreSignedResultUrls] = useState([]);
  const [chartNotes, setChartNotes] = useState([]);

  const resetSnackMsgAndErr = () => {
    setSnackSeverity("");
    setSnackText(null);
    setSnackOpen(false);
  };

  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity);
    setSnackText(text);
    setSnackOpen(true);
  };

  const handleSnackClose = () => {
    setSnackOpen(false);
  };

  const fetchTestResult = async kitId => {
    if (!isValidValue(kitId)) {
      handleSnackOpen("Kit ID is not valid", "error");
      return;
    }
    resetSnackMsgAndErr();
    try {
      const res = await ApiService.getTestResultByKitId(kitId);
      setTestResult(res?.data);
    } catch (error) {
      if (error?.response?.status === 404) {
        handleSnackOpen(`No test results found yet for Kit ID: ${kitId}. Please check back later.`, "info");
      } else {
        handleSnackOpen(`Unable to fetch test results for Kit ID: ${kitId}. Please try again later.`, "error");
      }
    }
  };

  const fetchKitDetails = async kitId => {
    (async () => {
      const res = await ApiService.getKitDetialsByKitId(kitId);
      setKitDetail(res?.data);
    })().then(r => r);
  };

  const getChartNotesByKitId = async kitId => {
    const chartNotesForKit = await ApiService.getChartNotesForKit(kitId);
    const chartNotesForTestResult = await ApiService.getChartNotesForTestResult(kitId);
    const chartNotes = [...chartNotesForKit?.data, ...chartNotesForTestResult?.data];
    const sortedChartNotes = chartNotes?.sort((a, b) => b.createdEpoch - a.createdEpoch);
    setChartNotes(sortedChartNotes || []);
  };

  useEffect(() => {
    resetSnackMsgAndErr();
    try {
      if (isValidValue(kitId)) {
        (async () => {
          await Promise.all([fetchTestResult(kitId), fetchKitDetails(kitId)]);
          const isClinicalDataAccess = await hasAccessToClinicalData();
          console.log("isClinicalDataAccess" + isClinicalDataAccess);
          setHasClinicalDataAccess(isClinicalDataAccess);
        })();
      }
    } catch (e) {
      console.error(e);
      handleSnackOpen(e.message || "Unknown internal error", "error");
    }
  }, []);
  useEffect(() => {
    try {
      getChartNotesByKitId(kitId);
    } catch (e) {
      console.error(e);
    }
  }, [kitId]);

  useEffect(() => {
    if (!testResult) {
      return;
    }
    (async () => {
      testResult?.attachments?.forEach(attachment => {
        if (isValidValue(attachment)) {
          (async () => {
            const resp = await ApiService.getPresignedUrl(attachment);
            const presignedUrl = resp?.data?.body?.url;
            console.log("presignedUrl" + presignedUrl);
            setPreSignedResultUrls(preSignedResultUrls => [...preSignedResultUrls, presignedUrl]);
          })().then(r => r);
        }
      });
    })();
  }, [testResult]);

  // function for send results
  function sendResult() {
    console.log("send to pass");
  }

  return (
    <>
      {kitDetail && (
        <Container fluid>
          <PageTitle titleName={"Kit Detail Page"} />
          {/*for now hide progress bar*/}
          {/*<Row>*/}
          {/*  <Col>*/}
          {/*    <Progress status={kitDetail?.status} />*/}
          {/*  </Col>*/}
          {/*</Row>*/}
          <Row>
            <Col xs={12} sm={12} md={9}>
              <div className={classes.root}>
                <Accordion defaultExpanded className="mt-2">
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" className="accordionTitle">
                    <Typography className={classes.heading}>Kit id : {kitDetail?.kitId}</Typography>
                  </AccordionSummary>
                  <AccordionDetails className="accordionDetails">
                    <KitDetails
                      labNameAndReqId={`${kitDetail?.labName || ""} - ${kitDetail?.requisitionId || ""}`}
                      kitId={kitDetail.kitId}
                      clinician={`${kitDetail?.clinician?.firstName} ${kitDetail?.clinician?.lastName}`}
                      productName={`${kitDetail?.productName}`}
                      symptoms={`${kitDetail?.symptoms}`}
                      DOR={new Date(kitDetail?.registrationDateTime).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        second: "numeric",
                        timeZoneName: "short"
                      })}
                      allergies={`${kitDetail?.patient?.allergies || "NA"}`}
                      medication={`${kitDetail?.patient?.medication || "NA"}`}
                      sampleCollectedDate={new Date(kitDetail?.testTakenDate).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        second: "numeric",
                        timeZoneName: "short"
                      })}
                    />
                  </AccordionDetails>
                </Accordion>
                <Accordion defaultExpanded className="mt-2">
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header" className="accordionTitle">
                    <Typography className={classes.heading}>
                      Patient Details
                      {!kitDetail?.patient && (
                        <h6>
                          <span style={{ color: "red" }}>
                            <MdOutlineDangerous /> PENDING PATIENT REGISTRATION <MdOutlineDangerous />
                          </span>
                        </h6>
                      )}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="accordionDetails">
                    <PatientDetails
                      pateintName={kitDetail?.patient?.name || "UNKNOWN"}
                      email={kitDetail?.patient?.email || "UNKNOWN"}
                      DOB={
                        kitDetail?.patient?.dob
                          ? DateTime.fromISO(kitDetail?.patient?.dob)
                              .toLocal()
                              .toFormat("LLL dd, yyyy")
                          : "UNKNOWN"
                      }
                      sex={kitDetail?.patient?.gender || "UNKNOWN"}
                      phoneNumber={kitDetail?.patient?.phoneNumber || "UNKNOWN"}
                      state={kitDetail?.patient?.address?.region || "UNKNOWN"}
                      passStatus={kitDetail?.patient?.shareWIthPass || "NA"}
                    />
                  </AccordionDetails>
                </Accordion>

                {hasClinicalDataAccess === true && (
                  <Accordion defaultExpanded className="mt-2">
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3a-content" id="panel3a-header" className="accordionTitle">
                      <Typography className={classes.heading}>Test Details</Typography>
                    </AccordionSummary>
                    <AccordionDetails className="accordionDetails">
                      <Typography>
                        {testResult?.results?.length > 0 ? (
                          <ResultDetails
                            testResults={testResult?.results}
                            hasAttachments={preSignedResultUrls?.length > 0}
                            attachments={preSignedResultUrls}
                            sendResult={sendResult}
                          />
                        ) : (
                          "No test results found"
                        )}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                )}

                {hasClinicalDataAccess === true && (
                  <Accordion defaultExpanded className="mt-2">
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header" className="accordionTitle">
                      <Typography className={classes.heading}>Charting Notes</Typography>
                    </AccordionSummary>
                    <AccordionDetails className="accordionDetails">
                      <Container fluid className="text-left mb-2">
                        <Row>
                          <Col>
                            <div className="tabsContent px-4">
                              {chartNotes.length > 0 &&
                                chartNotes.map((el, index) => (
                                  <SingleChart
                                    search={""}
                                    key={index}
                                    chartStatus={el?.status}
                                    referenceId={el?.referenceId}
                                    isClinicalRequired={el?.authorName ? false : true}
                                    authorName={el?.authorName}
                                    createdDate={convertEpochToDate(el?.createdEpoch)}
                                    chartDetails={el}
                                    noteMessage={el?.note}
                                    patientDetail={kitDetail?.patient || {}}
                                  />
                                ))}
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </AccordionDetails>
                  </Accordion>
                )}

                {hasClinicalDataAccess === true && (
                  <Accordion defaultExpanded className="mt-2">
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header" className="accordionTitle">
                      <Typography className={classes.heading}>External Patient Notes</Typography>
                    </AccordionSummary>
                    <AccordionDetails className="accordionDetails">
                      <Container fluid className="text-left mb-2">
                        <Row>
                          <Col>
                            {kitDetail?.externalNote ? (
                              <div
                                style={{ wordWrap: "break-word" }}
                                dangerouslySetInnerHTML={{
                                  __html: formatExternalNote(kitDetail.externalNote)
                                }}
                              />
                            ) : null}
                            {testResult?.externalNotes ? (
                              <div
                                style={{ wordWrap: "break-word" }}
                                dangerouslySetInnerHTML={{
                                  __html: formatExternalNote(testResult.externalNotes)
                                }}
                              />
                            ) : null}
                          </Col>
                        </Row>
                      </Container>
                    </AccordionDetails>
                  </Accordion>
                )}

                {/*<Accordion defaultExpanded className="mt-2">*/}
                {/*  <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header" className="accordionTitle">*/}
                {/*    <Typography className={classes.heading}>History/Logs</Typography>*/}
                {/*  </AccordionSummary>*/}
                {/*  <AccordionDetails className="accordionDetails">*/}
                {/*    <Container fluid className="text-left mb-2">*/}
                {/*      <PatientHistory />*/}
                {/*    </Container>*/}
                {/*  </AccordionDetails>*/}
                {/*</Accordion>*/}
              </div>
            </Col>
            <Col xs={12} sm={12} md={2}>
              <SelectActions
                testResult={testResult}
                kitDetail={kitDetail}
                kitId={kitId}
                patientDetails={kitDetail.patient || {}}
                clinicianDetails={kitDetail.clinician}
                status={kitDetail?.status}
                fetchChartNotes={() => getChartNotesByKitId(kitId)}
              />
            </Col>
          </Row>
          <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
            <Alert onClose={handleSnackClose} severity={snackSeverity}>
              {snackText}
            </Alert>
          </Snackbar>
        </Container>
      )}
    </>
  );
};

export default KitDetailsPage;
